import { SeriesPieOptions, Options } from "highcharts";
import { InsightColors } from "../shared/classes/models/InsightColors";

/* Generates common highcharts options types data types. Please add generic functionality. */

export class HighChartsFactory {

    // Generic Pie Chart for Dashboard/Home page
    public static createPieChartOptions(ChartData: SeriesPieOptions["data"], colors?: any): Options {
        return {
            title: {text:undefined},
            legend: {
              enabled: true
            },
            chart: {
              plotBackgroundColor: null,
              plotBorderWidth: null,
              plotShadow: false,
              type: 'pie',
            },
            plotOptions: {
              pie: {
                colors: colors || InsightColors.colorsArray,
                dataLabels: {
                  enabled: true,
                  formatter: function(): string { return this.percentage > 5 ? this.y + '' : ''},
                  borderWidth: 0,
                  style: {
                    fontSize: "20px",
                    textOutline: "none"
                  },
                  distance: -40,
                }
              }
            },
            tooltip: {
              pointFormat: '<b>{point.y}</b>'
            },
            series: [{
              dataLabels: {enabled: true},
              showInLegend: true,
              name: 'Brands',
              colorByPoint: true,
              data: ChartData,
              type: "pie"
            }]
        };
    }
}